import { AfterViewInit, Component, DestroyRef, forwardRef, inject, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import {
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { LegalDocumentsService } from '@app/core/legal-documents/legal-documents.service';
import { AbstractControlValueAccessor } from '@app/shared/abstract_control_value_accessor.abstract';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: 'privacy-policy.component.html',
  styleUrl: 'privacy-policy.component.scss',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PrivacyPolicyComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => PrivacyPolicyComponent), multi: true },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputErrorsComponent,
  ],
})

export class PrivacyPolicyComponent extends AbstractControlValueAccessor implements OnInit, AfterViewInit, Validator {
  private destroyRef = inject(DestroyRef);

  public readonly editMode = input<boolean>();
  public readonly customPrivacyPolicy = input<string>(undefined!);
  public readonly formErrors = input<Record<string, string> | null>(null);
  protected formControl = new FormControl<boolean>(false);
  protected readonly privacyPolicyHref = inject(LegalDocumentsService).getPrivacyPolicyHref();

  public ngOnInit(): void {
    this.formControl.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((value) => this.onFormChange(value));
  }

  public ngAfterViewInit(): void {
    if (this.customPrivacyPolicy()) {
      this.formControl.patchValue(true);
    }
    if (this.editMode()) {
      this.formControl.patchValue(true);
    }
  }

  public writeValue(value: boolean): void {
    this.formControl.patchValue(value, { emitEvent: false });
  }

  public validate(): ValidationErrors | null {
    return this.formControl.errors;
  }

  private onFormChange(value: boolean | null): void {
    this.onTouched();
    this.onChange(value);
  }
}
